import axios from 'axios';

export const isCancelError = (error) => axios.isCancel(error);

export const invokeApiWithCancel = (apiFn, params, getCancelTokenSource) => {
	if (getCancelTokenSource) {
		const cancelTokenSource = getCancelTokenSource();
		return apiFn(params, cancelTokenSource);
	}
	return apiFn(params);
};
